export default __webpack_public_path__ + "i18n/translations/translation-en.001fe9b5.json";